import React from 'react'
import AdditionalDataModal from './AdditionalDataModal'
import {
	TOTALS_MODAL,
	COMMISSION_MODAL,
	TOTALS_COLUMNS,
	COMMISSION_COLUMNS,
	CREATE_CUSTOMER_MODAL,
	DELETE_DOCUMENT_MODAL,
} from '../Reports/reports.constants'
import CreateCustomerModal from '../CreateCustomerModal/CreateCustomerModal'
import DeleteDocumentModal from '../DeleteDocumentModal/DeleteDocumentModal'

const getReportsModal = (modalName) => {
	let column = []
	switch (modalName) {
		case TOTALS_MODAL.TOTAL_ACCOUNTS:
			column = TOTALS_COLUMNS.TOTAL_ACCOUNTS
			break
		case TOTALS_MODAL.TOTAL_FFLS:
		case TOTALS_MODAL.TOTAL_DOCUMENTS:
			column = TOTALS_COLUMNS.TOTAL_FFLS_DOCUMENTS
			break
		case TOTALS_MODAL.TOTAL_ATF_AUDITS:
			column = TOTALS_COLUMNS.TOTAL_ATF_AUDITS
			break
		case TOTALS_MODAL.TOTAL_ATF_AUDITORS:
			column = TOTALS_COLUMNS.TOTAL_ATF_AUDITORS
			break
		case TOTALS_MODAL.TOTAL_GREEN_FLAGS_BY_FFLS:
			column = TOTALS_COLUMNS.TOTAL_GREEN_FLAGS_BY_FFLS
			break
		case TOTALS_MODAL.TOTAL_YELLOW_FLAGS_BY_FFLS:
			column = TOTALS_COLUMNS.TOTAL_YELLOW_FLAGS_BY_FFLS
			break
		case TOTALS_MODAL.TOTAL_RED_FLAGS_BY_FFLS:
			column = TOTALS_COLUMNS.TOTAL_RED_FLAGS_BY_FFLS
			break
		case TOTALS_MODAL.TOTAL_GREEN_FLAGS_BY_ATF:
			column = TOTALS_COLUMNS.TOTAL_GREEN_FLAGS_BY_ATF
			break
		case TOTALS_MODAL.TOTAL_YELLOW_FLAGS_BY_ATF:
			column = TOTALS_COLUMNS.TOTAL_YELLOW_FLAGS_BY_ATF
			break
		case TOTALS_MODAL.TOTAL_Red_FLAGS_BY_ATF:
			column = TOTALS_COLUMNS.TOTAL_Red_FLAGS_BY_ATF
			break
		case COMMISSION_MODAL.TOTAL_COMMISION:
			column = COMMISSION_COLUMNS.TOTAL_COMMISION
			break
		case COMMISSION_MODAL.TOTAL_CUSTOMERS:
			column = COMMISSION_COLUMNS.TOTAL_CUSTOMERS
			break
		case COMMISSION_MODAL.TOTAL_NEW_CUSTOMERS:
			column = COMMISSION_COLUMNS.TOTAL_NEW_CUSTOMERS
			break
		case COMMISSION_MODAL.RENEWING_CUSTOMERS:
			column = COMMISSION_COLUMNS.RENEWING_COUSTOMERS
			break
		case COMMISSION_MODAL.TOTAL_CHURNED_CUSTOMERS:
			column = COMMISSION_COLUMNS.TOTAL_CHURNED_COUSTOMERS
			break
		case COMMISSION_MODAL.UNENGAGED_USERS:
			column = COMMISSION_COLUMNS.UNENGAGED_USER
			break
		case COMMISSION_MODAL.LIFETIME_VALUE:
			column = COMMISSION_COLUMNS.LIFE_TIME_VALUE
			break
		case COMMISSION_MODAL.NEW_MRR:
			column = COMMISSION_COLUMNS.NEW_MRR
			break
		case COMMISSION_MODAL.AVG_PRODUCT_MIX:
			column = COMMISSION_COLUMNS.AVG_PRODUCT_MIX
			break
		case COMMISSION_MODAL.COMMISSION_DETAILS:
			column = COMMISSION_COLUMNS.COMMISSION_DETAILS
			break
		case CREATE_CUSTOMER_MODAL:
			return <CreateCustomerModal />
		case DELETE_DOCUMENT_MODAL:
			return <DeleteDocumentModal />
		default:
			return null
	}

	return <AdditionalDataModal column={column} />
}

export default getReportsModal
